import { Route } from "react-router-dom";
import Profile from "../../pages/Settings/Profile/Index";
import ManageDefaultRoutes from "../ManageDefaultRoutes";
import Permission from "../../pages/Settings/Permission/Index";
import Accessibility from "../../pages/Settings/Accessibility/Index";
import Preference from "../../pages/Settings/Preference/Index";
import ProductCube from "../../pages/Settings/ProductCube/Index";
import FeeSetup from "../../pages/Settings/Profile/FeeSetup/Index";
import PositionSetup from "../../pages/Settings/Profile/PositionSetup/Index";
import SetupClasses from "../../pages/Settings/Profile/SetupClasses/Index";
import TeamCreateSetup from "../../pages/Settings/Profile/TeamCreateSetup/Index";

const SettingRoutes = (
  <Route path="setting/*">
    <Route index element={<ManageDefaultRoutes path={"profile"} />} />
    <Route path="profile/*">
      <Route index element={<Profile />} />
      <Route path="setup/*">
        <Route path="fee" index element={<FeeSetup />} />
        <Route path="position" index element={<PositionSetup />} />
        <Route path="classes" index element={<SetupClasses />} />
        <Route path="team" index element={<TeamCreateSetup />} />
      </Route>
    </Route>

    <Route path="permission" element={<Permission />} />

    <Route path="permission" element={<Permission />} />
    <Route path="accissibility" element={<Accessibility />} />
    <Route path="perference" element={<Preference />} />
    <Route path="productcube" element={<ProductCube />} />

    {/* <Route path="*" element={<NotFound />} /> */}
  </Route>
);

export default SettingRoutes;
